import React, { useMemo } from 'react'
import geojson2svg from 'geojson-to-svg'

interface TypesCordenates {
  coordinates: [string | number, string | number]
  fill: string
  fillOpacity?: number
  multi?: boolean
  className?: string
}

const SvgTalhaoMemo: React.FC<TypesCordenates> = ({ coordinates, fill = 'green', multi = false, fillOpacity = 1, className }) => {

  // ✅ Só recalcula se coordinates, fill ou fillOpacity mudarem
  const svg = useMemo(() => {
    let pontos = []
    let features = []

    if (!coordinates) {
      return null
    }

    if (multi) {
      coordinates?.forEach((talhao) => {
        // @ts-ignore
        talhao.filter((e) => (e.latitude || e.lat) && (e.longitude || e.lng)).forEach((dados) => {
          pontos = [
            ...pontos,
            [
              // @ts-ignore
              dados.longitude || String(dados.lng),
              // @ts-ignore
              dados.longitude || dados.lng,
            ],
          ]
        })
      })

      features = [{
        type: 'Feature',
        geometry: { type: 'MultiPolygon', coordinates: [pontos] },
        properties: { thumb: 'basic' },
      }]
    } else {
      // @ts-ignore
      coordinates?.filter((e: any) => (e.latitude || e.lat) && (e.longitude || e.lng)).forEach((dados) => {
        pontos = [
          [
            // @ts-ignore
            dados.longitude || String(dados.lng),
            // @ts-ignore
            -(dados.latitude || dados.lat),
          ],
          ...pontos,
        ]
      })

      features = [{
        type: 'Feature',
        geometry: { type: 'Polygon', coordinates: [pontos] },
        properties: { thumb: 'basic' },
      }]
    }

    if (pontos.length === 0) return null

    return geojson2svg()
      .type('thumb')
      .styles({ basic: { fill, fillOpacity, strokeColor: '#ffffff' } })
      .data({ type: 'FeatureCollection', features })
      .render()

  }, [coordinates, fill, fillOpacity, multi]) // ✅ deps exatas

  return (
    <svg
      style={{ maxWidth: '50px', maxHeight: '50px', marginRight: 0 }}
      dangerouslySetInnerHTML={{ __html: svg ?? '' }}
      className={className ?? ""}
    />
  )
}

// ✅ React.memo evita re-render se as props não mudaram
export default React.memo(SvgTalhaoMemo)